import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LanguageToggle = () => {
  const { language, setLanguage, hasSelectedLanguage } = useLanguage();

  if (!hasSelectedLanguage) return null;

  return (
    <div 
      className="fixed top-4 right-4 z-40 flex items-center gap-1 bg-white/90 backdrop-blur-sm 
                 rounded-full px-1 py-1 shadow-lg border border-[#E6C288]"
      data-testid="language-toggle"
    >
      <button
        onClick={() => setLanguage('en')}
        className={`px-3 py-2 min-h-[40px] rounded-full text-sm font-medium transition-all duration-200
                   ${language === 'en' 
                     ? 'bg-[#800020] text-white shadow-md' 
                     : 'text-[#2D2424]/70 hover:bg-[#F5E6D3]'}`}
        data-testid="toggle-english"
      >
        EN
      </button>
      <button
        onClick={() => setLanguage('bn')}
        className={`px-3 py-2 min-h-[40px] rounded-full text-sm font-medium font-bangla transition-all duration-200
                   ${language === 'bn' 
                     ? 'bg-[#800020] text-white shadow-md' 
                     : 'text-[#2D2424]/70 hover:bg-[#F5E6D3]'}`}
        data-testid="toggle-bangla"
      >
        বাং
      </button>
    </div>
  );
};

export default LanguageToggle;
